import gql from 'graphql-tag';

import { PublicUserFragment, ContentFragment } from '../fragments';

export default gql`
  ${PublicUserFragment}
  ${ContentFragment}

  query getChannelPerks($id: UUID!) {
    channel(_id: $id) {
      _id
      description
      slug
      type
      settings {
        hasPerksEnabled
      }

      perks {
        ...ContentFragment
      }
    }
  }
`;
